<template>
  <ChartBase title="Sales Overview (Last 30 Days)" :loading="loading">
    <div class="chart-thirty-day-numbers-box pt-4">
      <v-row v-for="(stats, i) of statPairs" :key="`stat-group-${i}`">
        <v-col
          cols="6"
          v-for="(value, label) of stats"
          :key="label"
          class="text-center"
        >
          <div class="grey--text text--darken-1">{{ label }}</div>
          <hr
            style="border-top:1px dotted #CCC;border-bottom:0;"
            class="mb-2"
          />
          <div class="title stat-value">{{ value }}</div>
        </v-col>
      </v-row>
    </div>
  </ChartBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _toPairs from 'lodash/toPairs'
import _chunk from 'lodash/chunk'
import _fromPairs from 'lodash/fromPairs'
import _map from 'lodash/map'

import ChartBase from '@/components/ChartBase.vue'

export default {
  name: 'ChartThirtyDaySalesOverview',
  components: {
    ChartBase,
  },
  data() {
    return {
      loading: true,
      stats: {},
      statPairs: [],
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
  },
  async mounted() {
    const { data } = await this.getChartThirtyDaySalesOverview()
    this.stats = data.data
    this.statPairs = _map(_chunk(_toPairs(this.stats), 2), _fromPairs)
    this.loading = false
  },
  methods: {
    ...mapActions('shop', ['getChartThirtyDaySalesOverview']),
  },
}
</script>

<style scoped>
.chart-thirty-day-sales {
  height: 200px;
}
.stat-value {
  white-space: pre-line;
  line-height: 1.3;
}
</style>
